export const SIGNATURE_SUFFIX_COPY = {
  autoAdded: '· Auto-added',
  customized: '· Customized for this email',
} as const;

export const SIGNATURE_EDIT_HELPER_COPY = 'Changes apply to this email only. Your profile signature won’t be changed.';
